<script>
import { BAlert, BCard, BCardTitle, BLink } from 'bootstrap-vue'
import SubstanceList from "@/views/product/components/product-card/composition/SubstanceList.vue";
import Parents from "@/views/product/components/product-card/composition/Parents.vue";
import ComponentListItem from "@/views/product/components/product-card/composition/ComponentListItem.vue";

export default {
    components: {ComponentListItem, SubstanceList, Parents, BAlert, BCard, BCardTitle, BLink},
    props: {
        components: {
            type: Array,
            default() {
                return [];
            }
        },
        compactView: {
            type: Boolean,
            default: false
        },
        substanceLists: {
            type: Array,
            default() {
                return [];
            }
        }
    }
}
</script>

<template>
    <div>
        <ComponentListItem
            :component="component"
            :substance-lists="substanceLists"
            v-for="component in components"
        />
    </div>
</template>
